import { render } from "./ModalDialog.vue?vue&type=template&id=6230f929&scoped=true&ts=true"
import script from "./ModalDialog.vue?vue&type=script&lang=ts"
export * from "./ModalDialog.vue?vue&type=script&lang=ts"

import "./ModalDialog.vue?vue&type=style&index=0&id=6230f929&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6230f929"]])

export default __exports__